import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-bg"></div>
      <div className="hero-content container reveal">
        <h1 className="hero-title">Endüstriyel Şerit Testere Bıçakları ve <span className="highlight">Kesici Uçlar</span></h1>
        <p className="hero-subtitle">Daha hızlı kesim, daha düşük maliyet ve uzun ömürlü performans için bimetal, karbür ve elmas şerit testere çözümleri.</p>
        <div className="hero-cta">
          <a href="#products-overview" className="btn-primary">Ürünleri İncele</a>
          <a href="#product-finder" className="btn-secondary" style={{ backgroundColor: "rgba(255,255,255,0.1)", color: "white", borderColor: "rgba(255,255,255,0.2)" }}>Doğru Testereyi Bul</a>
        </div>
      </div>
      <div className="hero-stats container reveal delay-2">
        <div className="stat-card">
          <i className="fa-solid fa-arrow-trend-up"></i>
          <div>
            <h3>Uzun Ömürlü Bıçaklar</h3>
            <p>Birim zamanda en yüksek çıktı</p>
          </div>
        </div>
        <div className="stat-card">
          <i className="fa-solid fa-coins"></i>
          <div>
            <h3>Düşük Maliyet</h3>
            <p>Uzun bıçak ömrü ile tasarruf</p>
          </div>
        </div>
        <div className="stat-card">
          <i className="fa-solid fa-medal"></i>
          <div>
            <h3>Endüstriyel Kalite</h3>
            <p>Alman ve Amerikan mühendisliği</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
